import Special_specialevent from "./special/specialevent/main";

//specialページ汎用
const special = new Special_specialevent();